import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import patchCartsByParams from './patch-carts-by-params';

/**
 * @param {object} opts - args for patchCartsByParams minus actions which are shaped here
 * @see patchCartsByParams
 * @returns {Promise} promise result of patchCartsByParams
 */
export default function removeItemsByParams(opts) {
  var _opts$items = opts.items,
    items = _opts$items === void 0 ? [] : _opts$items,
    params = _objectWithoutProperties(opts, ["items"]);
  return patchCartsByParams(_objectSpread(_objectSpread({}, params), {}, {
    actions: items.map(function (item) {
      return {
        op: 'remove',
        path: '/items',
        value: item
      };
    })
  }));
}